import {
  SnippetPillsInputProps,
  SnippetsPillsInput as SnippetsPillsInputBase,
} from 'components/Wizards/Snippets/SnippetsPillsInput/SnippetsPillsInput'
import { useField, useFormikContext } from 'formik'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { useEffect, useRef } from 'react'
import { ProseInputHandle } from 'common/ProseInput/Types'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

interface Props extends Omit<SnippetPillsInputProps, 'pills' | 'onChange'> {
  name: string
  isSingleLine?: boolean
}

export const SnippetsPillsInput = ({ name, ...props }: Props) => {
  const { status } = useFormikContext()
  const [field, , helpers] = useField(name)

  const ref = useRef<ProseInputHandle | null>(null)

  useEffect(() => {
    ref.current?.replaceHTMLString?.(field.value)
  }, [status]) // eslint-disable-line react-hooks/exhaustive-deps

  if (status === FormStatus.AutoFilling) {
    return <TextFieldLoadingState lines={3} />
  }

  return (
    <SnippetsPillsInputBase
      {...props}
      pills={field.value}
      onChange={(pills) => helpers.setValue(pills)}
      size="lg"
      inputRef={ref}
    />
  )
}
